import React from "react";
import { useTranslation } from "react-i18next";
import "./ContactUs.css";
import ContactForm from "./ContactForm";

const ContactUs = () => {
  const { t } = useTranslation();
  return (
    <div className="contact-section-er">
      {/* Banner Section */}
      <div className="contact-banner-er">
        <h1 className="contact-banner-text-er">{t("contactForm.banner")}</h1>
      </div>
      <div className="contact-form-section">
        <div className="contact-form-container">
          <div className="con-form-section">
            <ContactForm />
            <div className="cont-3">
              <p>
                <svg
                  width="29"
                  height="29"
                  viewBox="0 0 29 29"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.2049 0.424255V2.35269C18.1123 2.35269 19.8992 2.8348 21.5657 3.79902C23.1518 4.74315 24.4167 6.00869 25.3603 7.59563C26.3241 9.26292 26.8059 11.0507 26.8059 12.9591H28.7334C28.7334 10.6892 28.1612 8.57994 27.0168 6.63141C25.9125 4.74315 24.4167 3.2466 22.5294 2.14177C20.5819 0.99676 18.4737 0.424255 16.2049 0.424255ZM6.23636 3.31691C5.69426 3.31691 5.22243 3.48766 4.82088 3.82915L1.71888 6.99299L1.80923 6.93273C1.30729 7.35458 0.976004 7.87686 0.815382 8.49959C0.674839 9.12231 0.714994 9.72495 0.935848 10.3075C1.49802 11.8743 2.25094 13.4814 3.19459 15.1286C4.51971 17.3985 6.09581 19.4374 7.92288 21.2453C10.8542 24.1983 14.4983 26.5285 18.8552 28.2359H18.8853C19.4675 28.4368 20.0498 28.477 20.6321 28.3565C21.2344 28.2359 21.7664 27.9748 22.2282 27.573L25.27 24.5297C25.6716 24.128 25.8723 23.6358 25.8723 23.0533C25.8723 22.4506 25.6716 21.9484 25.27 21.5467L21.3247 17.5693C20.9232 17.1675 20.4212 16.9666 19.8189 16.9666C19.2166 16.9666 18.7146 17.1675 18.3131 17.5693L16.4157 19.4977C14.8898 18.7745 13.5647 17.8806 12.4404 16.816C11.316 15.7312 10.4226 14.4155 9.75999 12.8687L11.6874 10.9403C12.1091 10.4983 12.3199 9.97604 12.3199 9.37341C12.3199 8.75068 12.079 8.24849 11.5971 7.86682L11.6874 7.95721L7.65183 3.82915C7.25028 3.48766 6.77845 3.31691 6.23636 3.31691ZM16.2049 4.28113V6.20957C17.4297 6.20957 18.554 6.51088 19.578 7.11352C20.622 7.71616 21.4452 8.53976 22.0475 9.58433C22.6499 10.6088 22.951 11.7337 22.951 12.9591H24.8785C24.8785 11.3922 24.487 9.93587 23.7039 8.58998C22.9209 7.28427 21.8769 6.2397 20.5718 5.45627C19.2266 4.67284 17.771 4.28113 16.2049 4.28113ZM6.23636 5.24535C6.29659 5.24535 6.36686 5.27548 6.44717 5.33574L10.3924 9.37341C10.4125 9.45376 10.3924 9.52407 10.3322 9.58433L7.47113 12.4167L7.68195 13.0194L8.07346 13.8631C8.39471 14.546 8.76614 15.2089 9.18778 15.8518C9.77003 16.7557 10.4125 17.5291 11.1152 18.1719C12.0589 19.0959 13.1933 19.9396 14.5184 20.703C15.181 21.0846 15.7431 21.3659 16.2049 21.5467L16.8073 21.8179L19.7286 18.8951C19.7687 18.8549 19.7988 18.8348 19.8189 18.8348C19.839 18.8348 19.8691 18.8549 19.9093 18.8951L23.975 22.9629C24.0151 23.003 24.0352 23.0332 24.0352 23.0533C24.0352 23.0533 24.0151 23.0733 23.975 23.1135L20.9633 26.0966C20.5216 26.4782 20.0398 26.5787 19.5177 26.3979C15.4219 24.8109 12.0087 22.6415 9.27812 19.8894C7.5916 18.202 6.11589 16.2836 4.851 14.1342C3.9475 12.5875 3.24478 11.0909 2.74284 9.64459V9.61446C2.66253 9.43367 2.65249 9.22275 2.71272 8.98169C2.77296 8.72055 2.88338 8.51967 3.044 8.37906L6.02554 5.33574C6.08577 5.27548 6.15605 5.24535 6.23636 5.24535ZM16.2049 8.138V10.0664C17.008 10.0664 17.6907 10.3477 18.2528 10.9101C18.815 11.4726 19.0961 12.1556 19.0961 12.9591H21.0236C21.0236 12.0953 20.8027 11.2918 20.361 10.5485C19.9394 9.8053 19.3571 9.22275 18.6142 8.8009C17.8714 8.35897 17.0683 8.138 16.2049 8.138Z"
                    fill="#3cf1c7"
                  />
                </svg>
                MOB.:
                <br />
                (+374 96) 45-45-03
              </p>
              <p>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10.0625 1.64062V6.5625H8.09375V4.59375H2.1875V22.3125H4.15625V23.2969C4.15625 24.0967 4.44336 24.7837 5.01758 25.3579C5.6123 25.9526 6.30957 26.25 7.10938 26.25C7.90918 26.25 8.59619 25.9526 9.17041 25.3579C9.76514 24.7837 10.0625 24.0967 10.0625 23.2969V22.3125H25.8125V6.5625H21.875V1.64062H10.0625ZM12.0312 3.60938H19.9062V8.53125H12.0312V3.60938ZM4.15625 6.5625H6.125V20.3438H4.15625V6.5625ZM8.09375 8.53125H10.0625V10.5H21.875V8.53125H23.8438V20.3438H8.09375V8.53125ZM11.0469 12.4688V14.4375H13.0156V12.4688H11.0469ZM14.9844 12.4688V14.4375H16.9531V12.4688H14.9844ZM18.9219 12.4688V14.4375H20.8906V12.4688H18.9219ZM11.0469 16.4062V18.375H13.0156V16.4062H11.0469ZM14.9844 16.4062V18.375H16.9531V16.4062H14.9844ZM18.9219 16.4062V18.375H20.8906V16.4062H18.9219ZM6.125 22.3125H8.09375V23.2969C8.09375 23.5635 7.99121 23.7993 7.78613 24.0044C7.60156 24.189 7.37598 24.2812 7.10938 24.2812C6.84277 24.2812 6.60693 24.189 6.40186 24.0044C6.21729 23.7993 6.125 23.5635 6.125 23.2969V22.3125Z"
                    fill="#3cf1c7"
                  />
                </svg>
                TEL.:
                <br />
                (+374 10) 39-87-57
              </p>
              <p>
                <svg
                  width="28"
                  height="28"
                  viewBox="0 0 28 28"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.95455 2.625V4.59624L1.75 8.63565V25.375H26.5682V8.63565L20.3636 4.59624V2.625H7.95455ZM10.0227 4.69318H18.2955V12.6428L14.1591 15.3249L10.0227 12.6428V4.69318ZM11.0568 6.76136V8.82955H17.2614V6.76136H11.0568ZM7.95455 7.0522V11.2855L4.6907 9.18501L7.95455 7.0522ZM20.3636 7.0522L23.6275 9.18501L20.3636 11.2855V7.0522ZM11.0568 9.86364V11.9318H17.2614V9.86364H11.0568ZM3.81818 11.0916L14.1591 17.7809L24.5 11.0916V23.3068H3.81818V11.0916Z"
                    fill="#3cf1c7"
                  />
                </svg>
                EMAIL:
                <br />
                developerhar.com
              </p>
            </div>
          </div>
          <div className="contact-img-container">
            <img src="/contact.png" alt="" />
          </div>
        </div>
      </div>
      {/* Social Media Icons */}
      <div className="social-icons">
        <a
          href="https://t.me/CodeRedHub"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/icons/telegram.png" alt="Telegram" />
        </a>
        <a
          href="https://www.facebook.com/profile.php?id=61555155434996&sk=photos"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/icons/facebook.png" alt="Facebook" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <img src="/icons/twitter.png" alt="X Twitter" />
        </a>
        <a
          href="https://www.tiktok.com/@code__red__hub"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/icons/tiktok.png" alt="tiktok " />
        </a>
        <a
          href="https://www.linkedin.com/company/codered-digital/?viewAsMember=true"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/icons/linkedin.png" alt="linkedin " />
        </a>
      </div>
    </div>
  );
};

export default ContactUs;
